export default {
    showModal: false,
    modalLayout: null,
    modalsSettings: {
        sameProducts: {
            title: 'Аналоги',
            layout: 'ModalSameProducts',
            description: null,
            size: 'big',
            props: {},
        },
        default: {
            title: '',
            layout: null,
            description: null,
            size: null,
            props: {},
        },
        errorInfo: {
            title: '',
            layout: null,
            description: null,
            size: 'small',
            props: {},
        },
    },
}
